// @flow
import * as React from 'react'
import FlatCard from 'ui/atoms/FlatCard'
import Heading from 'ui/atoms/Heading'
import Space from 'ui/atoms/Space'
import Text from 'ui/atoms/Text'

type Props = {
  children: React.Node,
  subtitle?: string | React.Node,
  title: string,
}

function FormBuilderSettingsCard({
  children,
  subtitle,
  title,
}: Props): React.Node {
  const renderSubtitle = React.useCallback(() => {
    if (!subtitle) return null

    if (typeof subtitle === 'string') {
      return <Text $light>{subtitle}</Text>
    }

    return subtitle
  }, [subtitle])

  return (
    <FlatCard
      $fullHeight
      className="overflow-auto !bg-transparent !pl-8"
      style={{ flex: 1 }}
    >
      <div className="w-full xl:w-3/4 xxl:w-4/5">
        <Space size="large">
          <div>
            <Heading>{title}</Heading>
            {renderSubtitle()}
          </div>
          <div className="md:w-full xxl:w-3/4">{children}</div>
        </Space>
      </div>
    </FlatCard>
  )
}

export default FormBuilderSettingsCard
